import {
  DiscoveryApi,
  discoveryApiRef,
  useApi,
} from '@backstage/core-plugin-api';

export function useDiscoveryApi(): DiscoveryApi {
  return useApi(discoveryApiRef);
}
